import { FileCategory } from './enums/file-category.enum';

export interface UploadFileDto {
  file: File;
  category: FileCategory;
}

export function toUploadFileFormData(dto: UploadFileDto, userId: number): FormData {
  const formData = new FormData();

  formData.append('File', dto.file);
  formData.append('Category', String(dto.category));
  formData.append('UserId', String(userId));

  return formData;
}
